import { useState } from 'react'

import { ProductFilter } from 'components/FiltersWheel/ProductFilter'
import { IntervalFilter } from 'components/FiltersWheel/IntervalFilter'
import { FiltersWheel } from 'components/FiltersWheel/FiltersWheel'
import { Product } from 'services/warehouse-containers/filters/store'
import { useProducts } from 'services/warehouse-containers/filters/store/hook'
import { OrderNumberFilter } from 'components/FiltersWheel/OrderNumberFilter'
import { ContainerSealFilter } from 'components/FiltersWheel/ContainerSealFilter'

export type Props = {
  onProductsChange: (products: string[]) => void
  onIntervalChange: (interval: [Date, Date]) => void
  onOrderNumberChange: (orderNumber: number) => void
  onContainerSealChange: (sealNumber: number) => void
}

export const Filter = ({
  onProductsChange,
  onIntervalChange,
  onOrderNumberChange,
  onContainerSealChange,
}: Props) => {
  const { products } = useProducts()

  const [selectedProducts, setSelectedProducts] = useState<Product[]>(null)
  const [interval, setInterval] = useState<[Date, Date]>([null, null])
  const [orderNumber, setOrderNumber] = useState<number>()
  const [seal, setSeal] = useState<number>()

  const handleOnProductChange = (value: Product[]) => {
    setSelectedProducts(value)
    onProductsChange(value?.map((el) => el.slug))
  }

  const handleOnIntervalChange = (value: [Date, Date]) => {
    setInterval(value)
    onIntervalChange(value)
  }

  const handleOnOrderNumberChange = (number: number) => {
    setOrderNumber(number)
    onOrderNumberChange(number)
  }

  const handleOnContainerSealChange = (containerSeal: number) => {
    setSeal(containerSeal)
    onContainerSealChange(containerSeal)
  }

  return (
    <FiltersWheel>
      <IntervalFilter values={interval} onSelect={handleOnIntervalChange} />
      <ProductFilter
        values={products}
        checked={selectedProducts}
        onSelect={handleOnProductChange}
      ></ProductFilter>
      <OrderNumberFilter values={orderNumber} onSelect={handleOnOrderNumberChange} />
      <ContainerSealFilter values={seal} onSelect={handleOnContainerSealChange} />
    </FiltersWheel>
  )
}
